var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.wrapper,_vm._b({tag:"component"},'component',_vm.bind,false),[_vm._t("default")],2),_c('v-scroll-y-transition',[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.showError),expression:"showError"}],style:({
        color: 'rgb(255, 82, 82)',
        fontWeight: '700',
        margin: 0
      })},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }